const FEATURE_FLAGS_FETCH_SUCCESS = "feature-flags::fetch::success";
const FEATURE_FLAGS_FETCH_FAILURE = "feature-flags::fetch::failure";

export { FEATURE_FLAGS_FETCH_SUCCESS, FEATURE_FLAGS_FETCH_FAILURE };
